<div class="content">
  <!-- Start Content-->
  <div class="container-fluid">
      
      <div class="row">
          <!-- game start -->
          <div class="col-md-12 px-1">
              <div class="horse">
                  
                  <div class="allreport">
                      <div class="sub_path"><p>set button value</p></div>
                      <div class="row p-1">
                          <div class="col-12">
                              <div class="table-responsive">
                                  <table class="table table-bordered nowrap">
                                      <thead>
                                          <tr>
                                              <th>ID</th>
                                              <th>Button Name</th>
                                              <th>Button Value</th>
                                          </tr>
                                      </thead>
                                      <tbody id="tblAccountStatement">
                                          <tr style="display: none;">
                                              <td colspan="9" class="text-center"><h5 class="text-danger font-weight-bold m-0">No Bets</h5></td>
                                          </tr>
                                          <tr *ngFor="let arr of stArr;let i=index;">
                                              <td class="w-8">1</td>
                                              <td class="w-46"><input [(ngModel)]="stacks['stake_amount_'+ (i+1)]" type="text" readonly /></td>
                                              <td class="w-46"><input name="stackVal{{i}}" [(ngModel)]="stacks['stake_amount_'+ (i+1)]" type="number"
                                                (change)="stacks['stake_name_'+ (i+1)] = stacks['stake_amount_'+ (i+1)]+'';" /></td>
                                          </tr>
                                          
                                      </tbody>
                                  </table>
                                  <app-loader class="full-overlay" *ngIf="isLoading"></app-loader>
                              </div>
                          </div>
                          <div class="col-12">
                              <button type="button" class="btn btn-update" (click)="setBtnVal()">submit</button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <!-- game end -->

      </div>
      <!-- end row -->
  </div> <!-- container -->
</div> <!-- content -->